export function isLDEntry(x) {
    return x && typeof x === "object" && "id" in x && "meta" in x;
}
export function toContainer(val) {
    if (val && typeof val === "object") {
        if ("index" in val)
            return val;
        if ("entries" in val)
            return val;
    }
    throw new Error("Value is not a container");
}
export function generateId() {
    return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}
export function determineType(v) {
    if (typeof v === "string")
        return "string";
    if (typeof v === "number")
        return "number";
    if (typeof v === "boolean")
        return "boolean";
    if (Array.isArray(v))
        return "array";
    return "object";
}
function meta(replicaId = "client") {
    return { updatedAt: Date.now(), version: 1, replicaId };
}
/** Convert plain JS to LDValue (RGA for arrays) */
export function toLDValue(v, replicaId = "client") {
    if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") {
        return v;
    }
    if (Array.isArray(v)) {
        const arr = { entries: {}, head: null, meta: meta(replicaId) };
        let prev = null;
        for (const item of v) {
            const id = generateId();
            const entry = {
                id,
                key: id,
                type: determineType(item),
                value: toLDValue(item, replicaId),
                meta: { ...meta(replicaId), after: prev },
            };
            arr.entries[id] = entry;
            prev = id;
        }
        arr.head = firstAfter(arr, null);
        return arr;
    }
    const index = {};
    for (const [k, val] of Object.entries(v)) {
        index[k] = {
            id: generateId(),
            key: k,
            type: determineType(val),
            value: toLDValue(val, replicaId),
            meta: meta(replicaId),
        };
    }
    return { index, meta: meta(replicaId) };
}
/** helper used by toLDValue array build */
function firstAfter(arr, after) {
    // find any element with meta.after===after; deterministic pick by id
    const ids = Object.keys(arr.entries).filter(id => { var _a; return ((_a = arr.entries[id].meta.after) !== null && _a !== void 0 ? _a : null) === after; });
    if (ids.length === 0)
        return null;
    ids.sort(); // deterministic (used only during initial build)
    return ids[0];
}
